import { createRouter, createWebHistory, useRoute } from 'vue-router';
import { useMainStore } from '@/stores/store.js';
import { fetchRoomTypeData } from '@/data.js';

import Start from '@/components/StepStart.vue';
import Project from '@/components/StepProject.vue';
import Room from '@/components/StepRoom.vue';
import Product from '@/components/StepProduct.vue';
import Report from '@/components/StepReport_v2.vue'; // Updated to use v2

const routes = [
    {
        path: '/',
        name: 'Start',
        component: Start,
    },
    {
        path: '/project/',
        name: 'Project',
        component: Project,
    },
    {
        path: '/room/',
        name: 'Room',
        component: Room,
    },
    {
        path: '/product/:id?',
        name: 'Product',
        component: Product,
    },
    {
        path: '/report/',
        name: 'Report',
        component: Report,
    },
    { path: '/:pathMatch(.*)*', redirect: '/' }, // Fallback route to root of the app.
];

const router = createRouter({
    history: createWebHistory('/acoustic-analyzer/'),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // Always scroll to top when navigating between steps
        return { top: 0, behavior: 'smooth' };
    },
});

// Attach beforeEach guard
router.beforeEach((to, from, next) => {
    const store = useMainStore();
    // Ensure the store is updated with the current route name
    // when the user has clicked the browser forward/back buttons.
    store.user.currentStepName = to.name;
    next(); // Always call next() to proceed
});

export default router;
